export const AuthRightPanel = ({ bgImage }) => {
    const panelBgImage = bgImage ||'';

    return (
        <div className="md:col-span-6 md:!block hidden relative w-full h-full overflow-hidden">
            {bgImage && (
                <img
                    src={bgImage}
                    alt=""
                    fetchpriority="high"
                    loading="eager"
                    decoding="async"
                    className="absolute inset-0 w-full h-full object-cover"
                />
            )}
        </div>
    );
};
